import { useEffect } from "react";

// react-helmet is inert in this app; pages set document.title directly.
// PageMeta handles title + robots meta for conditional states (404s, thank-you pages).
const PageMeta = ({ title, robots }) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    let tag = null;
    let created = false;
    let prevContent = null;
    if (robots) {
      tag = document.querySelector('meta[name="robots"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = "robots";
        document.head.appendChild(tag);
        created = true;
      }
      prevContent = tag.getAttribute("content");
      tag.setAttribute("content", robots);
    }

    return () => {
      document.title = prevTitle;
      if (tag) {
        if (created) tag.remove();
        else tag.setAttribute("content", prevContent || "");
      }
    };
  }, [title, robots]);

  return null;
};

export default PageMeta;
